/* eslint-disable no-nested-ternary */
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { styled } from 'linaria/react';
import { debounce } from 'lodash';
import { useFormikContext } from 'formik';
import { useCyberStore } from '@entities/tsp';
import { PaymentFormValues } from '@entities/payment';
import { currencySymbols, reqHeaders, STEAM_COURSE } from '@shared/config';
import { baseColors, withTheme } from '@shared/lib/theme';
import { Tooltip } from '@shared/ui/organisms';
import { Spinner, Text } from '@shared/ui/atoms';
import { SquareQuestionIcon, SteamIcon } from '@shared/assets/icons';
import { ICourseSteam } from '../../model/payment.types';

// refactor
const SteamFinalAccountAmount: FC = () => {
  const [isPriceLoading, setIsPriceLoading] = useState<boolean>(false);
  const [courseSteam, setCourseSteam] = useState<ICourseSteam | null>({
    account_status: '',
    usd_topup: '',
    rub_topup: '',
    kzt_topup: ''
  });
  const [error, setError] = useState<boolean>(false);
  const {
    values
  } = useFormikContext<PaymentFormValues>();
  const {
    activeCountrySteam
  } = useCyberStore();
  const iconAxiosRequest = useRef(null);
  const iconAxiosRequestAbortController = useRef(new AbortController());
  const debouncedHandleRequest = useCallback(debounce((url, params, options: RequestInit) => fetch(`${url}?${params}`, options).then(response => {
    if (!response.ok) {
      setError(true);
      setIsPriceLoading(false);
    }
    return response.json();
  }).then((data: ICourseSteam) => {
    if (data.usd_topup === '0') {
      setCourseSteam(null);
      setIsPriceLoading(false);
      return;
    }
    setCourseSteam(data);
    setIsPriceLoading(false);
  }).catch(error => {
    if (error.name !== 'AbortError') {
      setError(true);
      setIsPriceLoading(false);
    }
  }), 500), []);
  const updatePriceSteam = (value: string) => {
    setIsPriceLoading(true);
    if (iconAxiosRequest.current) {
      iconAxiosRequestAbortController.current.abort();
      iconAxiosRequestAbortController.current = new AbortController();
    }
    const url = 'https://keys.foreignpay.ru/webhook/v2/topup/check_rate';
    const params = new URLSearchParams({
      amount: String(value),
      account: values?.login || 'petrosovvput155'
    });
    const options = {
      method: 'GET',
      ...reqHeaders,
      signal: iconAxiosRequestAbortController.current.signal
    };
    iconAxiosRequest.current = debouncedHandleRequest(url, params, options) as unknown as null;
  };
  const updateValuePrice = (price: string) => {
    if (price !== null || price !== '') {
      updatePriceSteam(price);
    } else {
      setCourseSteam(null);
    }
  };
  useEffect(() => {
    updateValuePrice(values?.price);
  }, [values?.price]);
  const getCurrency = country => {
    switch (country) {
      case 'Страны СНГ':
        return 'USD';
      case 'Казахстан':
        return 'KZT';
      default:
        return 'RUB';
    }
  };
  const getValueCourse = (courseSteam, country) => {
    switch (country) {
      case 'Страны СНГ':
        return courseSteam?.usd_topup;
      case 'Казахстан':
        return courseSteam?.kzt_topup;
      default:
        return courseSteam?.rub_topup;
    }
  };
  const currency = getCurrency(activeCountrySteam);
  // const placeholder = getPlaceholder(activeCountrySteam)
  const valueCourse = getValueCourse(courseSteam, activeCountrySteam);

  // const error = error

  return <SteamFinalAccountAmountOuterWrapper>
      <SteamFinalAccountAmountInnerWrapper>
        <TextWrapper>
          <Text family="MTSCompact" size={{
          desktop: 'pS',
          mobile: 'pS'
        }} weight="medium" color={baseColors.cyan_300}>
            Получите на Steam
          </Text>
          <FinalAmountTextWrapper>
            {isPriceLoading ? <Spinner /> : <>
                <Text family="MTSCompact" size={{
              desktop: 'pL',
              mobile: 'pL'
            }} weight="medium" color={baseColors.cyan_300}>
                  ~ {valueCourse} {currencySymbols[currency]}
                </Text>
                <TooltipWrapper>
                  <Tooltip title={'Как рассчитывается сумма к\u00A0зачислению?'} content={'С учётом курсовой разницы на\u00A0стороне Steam и\u00A0провайдера услуг — до\u00A07%. Может меняться каждый час.'} position="top">
                    <SquareQuestionIcon />
                  </Tooltip>
                </TooltipWrapper>
              </>}
          </FinalAmountTextWrapper>
        </TextWrapper>
        <SteamIconWrapper>
          <SteamIcon />
        </SteamIconWrapper>
      </SteamFinalAccountAmountInnerWrapper>
      {error && <Text family="MTSCompact" weight="regular" size="captionL" color="negative">
          {STEAM_COURSE}
        </Text>}
    </SteamFinalAccountAmountOuterWrapper>;
};
export default SteamFinalAccountAmount;
const SteamFinalAccountAmountOuterWrapper = /*#__PURE__*/styled('div')({
  name: "SteamFinalAccountAmountOuterWrapper",
  class: "sdyt0gr",
  propsAsIs: false
});
const SteamFinalAccountAmountInnerWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "SteamFinalAccountAmountInnerWrapper",
  class: "s2plbp1",
  propsAsIs: false
}));
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t1yjmaxn",
  propsAsIs: false
});
const SteamIconWrapper = /*#__PURE__*/styled('div')({
  name: "SteamIconWrapper",
  class: "s1blnnhv",
  propsAsIs: false
});
const FinalAmountTextWrapper = /*#__PURE__*/styled('div')({
  name: "FinalAmountTextWrapper",
  class: "f14gbmwy",
  propsAsIs: false
});
const TooltipWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "TooltipWrapper",
  class: "t7kkd58",
  propsAsIs: false
}));

require("./SteamFinalAccountAmount.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SteamFinalAccountAmount.tsx");